<template>
    <div class="tableHeaderCheckboxFilter">
        <checkbox-grid
            :items="outerModel"
            :fields="{ title: 'item', subtitle: 'item', selected: 'selected' }"
            selection-buttons
            small-buttons
        >
            <slot v-if="$slots.default"></slot>
            <template v-if="isCountBadgeDisplayed" v-slot:titlePostfix="{ item }">
                <span class="badge countBadge">
                    {{ item.count }}
                </span>
            </template>
        </checkbox-grid>
    </div>
</template>

<script>
import CheckboxGrid from '../../checkboxGrid/CheckboxGrid';
import { watchIsFilterActive } from './mixins/tableHeaderFilter';

function isFilterActive(filterEntries) {
    return Array.isArray(filterEntries) && filterEntries.some(entry => entry.selected);
}

export default {
    name: 'TableHeaderCheckboxFilter',

    components: {
        CheckboxGrid
    },

    mixins: [watchIsFilterActive],

    model: {
        prop: 'outerModel'
    },

    props: {
        outerModel: {
            type: Array,
            required: true,
            validator(value) {
                return value.every(entry => entry.hasOwnProperty('item') && entry.hasOwnProperty('selected'));
            }
        }
    },
    computed: {
        isFilterActive() {
            return isFilterActive(this.outerModel);
        },
        isCountBadgeDisplayed() {
            return this.outerModel.length > 0 && this.outerModel.every(entry => entry.hasOwnProperty('count'));
        }
    }
};
</script>
